import "../../src/Fonts/font.css";

export default function NotFound() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <div className="h1" style={{ color: "#eb3c96"}}>
        404 NOTFOUND
      </div>
    </div>
  )
}